module.exports = __webpack_public_path__ + "img/KNA.1713e7c3.gif";